import React, { useState } from 'react'
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { useModalContext } from '../../contexts/ModalContext';
import SingleDepositHistory from './SingleDepositHistory';
import CardTransaction from './CardTransaction';
import InternalHistory from './InternalHistory';


const TransactionHistory = () => {
    const [activeTab, setActiveTab] = useState('Assets');
    const { theme } = useModalContext();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <div className='SettingsPageMain '>
            <div className="ad_pg_bx p-2" style={{ minHeight: "70vh" }}>
                <Nav tabs className='mb-4' style={{ background: theme ? '#000' : '#ffff' }}>
                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'Assets' })} onClick={() => { toggle('Assets'); }}>Assets History</NavLink>
                    </NavItem>
                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'internal' })} onClick={() => { toggle('internal'); }}>Internal History</NavLink>
                    </NavItem>
                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'card' })} onClick={() => { toggle('card'); }}>Card History </NavLink>
                    </NavItem>

                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="Assets">
                        {activeTab === "Assets" && <SingleDepositHistory />}
                    </TabPane>
                    <TabPane tabId="internal">
                        {activeTab === "internal" && <InternalHistory />}
                    </TabPane>
                    <TabPane tabId="card">
                        {activeTab === "card" && <CardTransaction />}
                    </TabPane>


                </TabContent>
            </div>
        </div>
    )
}

export default TransactionHistory